    <!-- invoice Payment modal -->
    <div class="modal fade" id="invoicePayment" data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered " >
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">Invoice Payment</h5>
                    <button type="button" class="btn" (click)="closeModal()">X</button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="row">
                            <div class="col-lg-7 col-sm-12">
                                <div class="row">
                                    <div class="col-7">
                                        <b>Premium Amount:</b>
                                    </div>
                                    <div class="col-4">
                                        {{currencyService.formatAmount(invoicePaymentDetails.premiumAmount)}}
                                    </div>
                                </div>
                                <div class="row" *ngIf="isEmployee">
                                    <div class="col-7">
                                        <b>Misc Fee:</b>
                                    </div>
                                    <div class="col-4">
                                        {{currencyService.formatAmount(invoicePaymentDetails.miscFee)}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-7">
                                        <b>Bank Fee:</b>
                                    </div>
                                    <div class="col-4">
                                        {{currencyService.formatAmount(invoicePaymentDetails.bankFee)}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-7">
                                        <b>Total Payment:</b>
                                    </div>
                                    <div class="col-4">
                                        {{currencyService.formatAmount(invoicePaymentDetails.totalPayment)}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-5 col-sm-12">
                                <div class="row" *ngIf="isEmployee">
                                    <div class="col-6">
                                        <b>Invoice #:</b>
                                    </div>
                                    <div class="col-3">
                                        {{invoicePaymentDetails.invoiceNumber}}
                                    </div>
                                </div>

                                <div class="row" *ngIf="!isEmployee">
                                    <div class="col-4">
                                        <b>GB #:</b>
                                    </div>
                                    <div class="col-8">
                                        {{invoicePaymentDetails.groupbillNo}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                <b>Payment Method:</b>
                            </div>
                            <div class="col-6">
                                {{invoicePaymentDetails.paymentMethod}}
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-primary" (click)="processInvoicePayment()">Process
                            Payment</button>
                </div>
            </div>
        </div>
    </div>



<!-- Failed Payment Modal -->
<div class="modal fade" id="failedPayment" data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Failed Payment</h5>
                <button type="button" class="close btn" data-dismiss="modal" (click)="closeModal()"
                    aria-label="Close">X</button>
            </div>
            <div class="modal-body modal-body-id-cards">
                <div class="col-sm-12 span-error text-danger">{{validationMessage.PAYMENT_HAS_FAILED}}
                    {{this.failedPaymentError}}.</div>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="closeModal()">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="paymentWarningModal" data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body modal-body-id-cards">
                <div class="col-sm-12 span-error">{{paymentWarningMessage}}</div>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btn btn-primary btn-rounded" data-dismiss="modal" (click)="closeWarningModal()">OK</button>
            </div>
        </div>
    </div>
</div>
